import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';

class HeaderBack extends React.Component {
  render() {
    const {
      name = 'content.layout.sidebarAndHeader.myAccount',
      title = 'content.common.backToProfile',
      link = 'routes.url.account',
      className,
      onClick
    } = this.props;

    var titleTranslated = TransHelper.translate(
      this.props.locale,
      title
    );

    var nameTranslated = TransHelper.translate(
      this.props.locale,
      name
    );

    return (
      <div className={`header-back ` + className}>
        <AppLink
          to={link}
          title={titleTranslated}
          className="link-back"
          onClick={onClick}
        >
          <FontAwesomeIcon
            icon={['fas', 'angle-left']}
          />
          <span>{nameTranslated}</span>
        </AppLink>
      </div>
    );
  }
}

export default HeaderBack;
